import { createPortal } from 'react-dom'

export function Portal({ children, isOpen, containerId = 'modal-root' }) {
  let container = document.body.querySelector(`div#${containerId}`)

  const containerExists = document.body.contains(container)

  if (!containerExists) {
    container = document.createElement('div')
    container.setAttribute('id', containerId)

    document.body.appendChild(container)
  }

  if (!isOpen) {
    document.body.removeChild(container)
    return null
  }

  return createPortal(children, container)
}
